import * as m from "@paraglide/messages"
import type { SponsorshipStartDateSelectionProps } from "@site-types/sendMail"
import { useEffect } from "react"
import { FormSelect } from "../FormSelect"
import { useSendMailLang } from "../langContext"

export const SponsorshipStartDateSelection = ({ value, setValue }: SponsorshipStartDateSelectionProps) => {
  const lang = useSendMailLang()

  const startDates = [
    m.contact_formPurpose_startDate_label_3months({}, { locale: lang }),
    m.contact_formPurpose_startDate_label_3to6months({}, { locale: lang }),
    m.contact_formPurpose_startDate_label_6monthsTo1year({}, { locale: lang }),
    m.contact_formPurpose_startDate_label_notSure({}, { locale: lang }),
  ]

  useEffect(() => {
    if (!value || value === "") {
      setValue(
        "formSponsorshipStartDate",
        m.contact_formPurpose_startDate_label_3months({}, { locale: lang }),
        {
          shouldValidate: true,
        }
      )
    }
  }, [value, setValue, lang])

  return (
    <div className="relative mb-8 flex flex-col">
      <label
        className="py-4"
        htmlFor="form-sponsorshipstart-list"
      >
        {m.contact_formPurpose_startDate_title({}, { locale: lang })}{" "}
        {m.contact_form_required({}, { locale: lang })}
      </label>
      <FormSelect
        id="form-sponsorshipstart-list"
        name="sponsorshipstart"
        value={value}
        onValueChange={(next) =>
          setValue("formSponsorshipStartDate", next, { shouldValidate: true, shouldDirty: true })
        }
        options={startDates}
        required
      />
    </div>
  )
}
